import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './theme/index.css'
import ElementUI from 'element-ui'
import Utils from './common/utils'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.Utils = Utils

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
